'use strict';
// TODO boundaryGap


    require('../coord/cartesian/AxisModel');

    require('./axis/CartesianAxisView');



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/axis.js
// module id = 1208
// module chunks = 158